import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }

import { v4 as uuidv4 } from 'uuid'
import { shallowRef, shallowReactive } from 'vue'
import router from '@/router'
import { ITableData, TableBody, ERowTypes, CustomCell } from '@/types/interfaces/table'
import { UiDataTable, UiLabelsGroup, UiDropdownMenu, UiMenuDots } from '@/components/common/ui'
import { IDropdownMenuItem } from '@/types/interfaces/dropdownMenu'
import { useInvoices, Invoice, InvoiceCorrection } from '@/composables/useInvoices'
import { useAdviceDocuments, InvoiceFormModes } from '@/composables/useAdviceDocuments'

type Props = {
    invoices: Invoice[]
}

export default /*#__PURE__*/_defineComponent({
  props: {
    invoices: { type: Array, required: true }
  },
  setup(__props: any) {

const props = __props as {
    invoices: Invoice[]
}
/* eslint-disable vue/html-closing-bracket-newline */
/* eslint-disable vue/html-indent */
/* eslint-disable indent */
/* eslint-disable prettier/prettier */
/* eslint-disable vue/no-v-html */
const { downloadAttachment, downloadInvoice } = useInvoices()

const {
    addAdviceToStorage,
    addInvoiceFile,
    addAttachmentFiles,
    setInvoiceValue,
    setInvoiceFormMode,
    setEditedInvoiceName,
    setEditedInvoiceId,
    removeAllSelectedAdvicesFromStorage,
} = useAdviceDocuments()



const tableData: ITableData = shallowReactive({ head: [], body: [] })

const isCustomType = (f: TableBody): f is CustomCell => {
    return typeof f === 'object' && f !== null && (f as CustomCell).data !== undefined
}
const isComponentType = (f: TableBody): f is CustomCell => {
    return (
        typeof f === 'object' &&
        f !== null &&
        (f as CustomCell).component !== undefined &&
        (f as CustomCell).componentConfig !== undefined
    )
}
tableData.head = [
    'Faktura',
    'Numer Faktury',
    'Data dodania',
    'Załączniki',
    'Zlecenie',
    'Status',
    'Wartość FV brutto',
    'Komentarz',
    'Akcje',
]
const _invoicesList = shallowRef<TableBody[][]>([])

const addRegularInvoiceRow = (row: Invoice): TableBody[] => {
    return [
        {
            type: ERowTypes.COMPONENT,
            component: UiLabelsGroup,
            componentConfig: {
                customLabelClass: 'cursor-pointer',
                labels: [row.filenamePdf || ''],
                asString: true,
                labelClick: () => {
                    downloadInvoice(row.id, row.filenamePdf && row.filenamePdf?.split('.')[0])
                },
            },
        },
        {
            type: ERowTypes.COMPONENT,
            component: UiLabelsGroup,
            componentConfig: {
                labels: [row.number],
                asString: true,
                customLabelClass: 'break-words',
            },
        },
        row.createdAt,
        {
            type: ERowTypes.COMPONENT,
            component: UiLabelsGroup,
            componentConfig: {
                customLabelClass: 'cursor-pointer break-words',
                labels: row.attachments
                    ? row.attachments.map(attachment => attachment.filename)
                    : [],
                asString: true,
                labelClick: (index: number | undefined) => {
                    if (index !== undefined && row.attachments[index]) {
                        downloadAttachment(
                            row.attachments[index].id,
                            row.attachments[index].filename.split('.')[0],
                        )
                    }
                },
            },
        },
        {
            type: ERowTypes.COMPONENT,
            component: UiLabelsGroup,
            componentConfig: {
                labels: row.advices ? row.advices.map(advice => advice.axId) : [],
                customWrapperClass: 'max-w-min',
            },
        },
        row.status.name,
        `${row.amount || '---'} zł`,
        {
            type: ERowTypes.COMPONENT,
            component: UiLabelsGroup,
            componentConfig: {
                labels: [row.description],
                asString: true,
                customLabelClass: 'break-words',
            },
        },
        {
            type: ERowTypes.HIDDEN,
            data: {
                id: row.id,
                status: row.status.name,
                type: 'regular',
            },
        },
    ]
}
const addCorrectionInvoiceRow = (correction: InvoiceCorrection, invoice: Invoice) => [
    {
        type: ERowTypes.HTML,
        html: `
            <span style="display: block; font-size: 12px;">Korekta do faktury ${
                invoice.number || ''
            }</span>
        `,
    },
    correction.number,
    correction.createdAt,
    {
            type: ERowTypes.COMPONENT,
            component: UiLabelsGroup,
            componentConfig: {
                customLabelClass: 'cursor-pointer break-words',
                labels: correction.attachments
                    ? correction.attachments.map(attachment => attachment.filename)
                    : [],
                asString: true,
                labelClick: (index: number | undefined) => {
                    if (index !== undefined && correction.attachments[index]) {
                        downloadAttachment(
                            correction.attachments[index].id,
                            correction.attachments[index].filename.split('.')[0],
                        )
                    }
                },
            },
        },
    {
        type: ERowTypes.COMPONENT,
        component: UiLabelsGroup,
        componentConfig: {
            labels: invoice.advices ? invoice.advices.map(advice => advice.axId) : [],
        },
    },
    correction.status.name,
    `${correction.amount || '---'} zł`,
    correction.description,
    {
        type: ERowTypes.HIDDEN,
        data: {
            id: correction.id,
        },
    },
    {
        type: ERowTypes.HIDDEN,
        data: {
            id: correction.id,
            status: correction.status.name,
            type: 'correction',
        },
    },
]
props.invoices.forEach(invoice => {
    invoice && _invoicesList.value.push(addRegularInvoiceRow(invoice))

    if (invoice.correction) {
        _invoicesList.value.push(addCorrectionInvoiceRow(invoice.correction, invoice))
    }
})

tableData.body = _invoicesList.value

const onInvoiceCorrection = (invoice: TableBody[]) => {
    goToInvoiceForm(invoice, 'correction-invoice', InvoiceFormModes.CORRECTION)
}
const goToInvoiceForm = async (
    invoice: TableBody[],
    routeName: string,
    invoiceFormMode: InvoiceFormModes,
) => {
    if (Array.isArray(invoice)) {
        const hiddenRow = invoice.find(
            e => typeof e === 'object' && isCustomType(e) && e?.type === ERowTypes.HIDDEN,
        )

        let invoiceId = 0
        if (hiddenRow && isCustomType(hiddenRow) && hiddenRow?.data?.id) {
            invoiceId = hiddenRow?.data?.id
        }

        if (invoiceId) {
            const exactInvoice = props.invoices.find(e => e.id === invoiceId)

            await removeAllSelectedAdvicesFromStorage()

            setEditedInvoiceName(exactInvoice?.number || '')
            setEditedInvoiceId(invoiceId)

            setInvoiceFormMode(invoiceFormMode)

            if (exactInvoice) {
                exactInvoice.advices.forEach(async advice => {
                    await addAdviceToStorage(advice, false)
                })
                await addInvoiceFile({
                    name: exactInvoice?.filenamePdf || 'file',
                    base64: '',
                    id: uuidv4(),
                    type: '',
                })
                let attachments: {
                    name: string
                    base64: string
                    type: string
                    id: string | number
                }[] = []

                if (Array.isArray(exactInvoice?.attachments)) {
                    attachments = exactInvoice.attachments.map(e => {
                        return {
                            name: e.filename,
                            base64: '',
                            type: '',
                            id: e.id || uuidv4(),
                        }
                    })
                }
                await addAttachmentFiles(attachments)
                setInvoiceValue(String(exactInvoice?.amount ?? ''))
            }

            router.push({ name: routeName })
        }
    }
}
const getDropdownMenuItems = (row: TableBody[]): IDropdownMenuItem[] => {
    const menuItems: IDropdownMenuItem[] = []

    const exactInvoice: Invoice | undefined = props.invoices.find(
        e => isCustomType(row[8]) && e.id === row[8]?.data?.id,
    )

    if (!exactInvoice?.correction) {
        menuItems.push({
            label: 'Korekta',
            name: 'correction',
            handler: () => {
                onInvoiceCorrection(row)
            },
        })
    }

    return menuItems
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UiDataTable), { data: _unref(tableData) }, {
    "row-title": _withCtx((slotProps) => [
      (
                    typeof slotProps?.row[8] === 'object' &&
                    slotProps?.row[8]?.data?.type === 'regular' &&
                    isComponentType(slotProps.row[1])
                )
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(slotProps.row[1]?.componentConfig?.labels
                        ? slotProps.row[1]?.componentConfig?.labels[0]
                        : ''), 1))
        : _createCommentVNode("", true)
    ]),
    "row-actions": _withCtx(({ row }) => [
      (
                    isCustomType(row[8]) &&
                    row[8]?.data?.type === 'regular' &&
                    row[8]?.data?.status !== 'posted' &&
                    getDropdownMenuItems(row).length > 0
                )
        ? (_openBlock(), _createBlock(_unref(UiDropdownMenu), {
            key: 0,
            items: getDropdownMenuItems(row)
          }, {
            "menu-button": _withCtx(() => [
              _createVNode(_unref(UiMenuDots))
            ]),
            _: 2
          }, 1032, ["items"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})